'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--ModernMic';

var EntypoModernMic = function EntypoModernMic(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M1.228,10.891c-0.221,0.148-0.292,0.46-0.159,0.69l1.296,2.244c0.133,0.23,0.438,0.325,0.677,0.208L7,12.116V19h2v-7.854l4.071-1.973l-2.62-4.54L1.228,10.891z M18.457,3.037c-1.121-1.94-3.604-2.605-5.546-1.484c-0.91,0.525-1.508,1.359-1.801,2.289l2.976,5.156c0.951,0.212,1.973,0.11,2.885-0.415C18.913,7.462,19.578,4.98,18.457,3.037z' })
    );
};

exports.default = EntypoModernMic;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-entypo-icons/lib/entypo/ModernMic.js
// module id = 7443
// module chunks = 0